<template>
  <div>
    <div class="input-group" style="width: 100px;">
      <input ref="timepicker" type="text" data-error="#err-day-time-start" class="form-control form_datetime_time_only no-focus" :class="{'is-invalid': layoutData.errorText != null}" :value="valueData" />
      <span class="input-group-btn">
        <button class="btn default" type="button">
          <i class="fa fa-clock-o"></i>
        </button>
      </span>
    </div>
    <div id="err-day-time-start"></div>
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-time",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      }
    },
    mounted () {
      $(this.$refs.timepicker).datetimepicker({
        autoclose: true,
        minuteStep: 15,
        isRTL: App.isRTL(),
        format: "hh:ii",
        pickerPosition: (App.isRTL() ? "bottom-right" : "bottom-left"),
        maxView: 1,
        startView: 1,
      }).on("change", (e) => {
        this.valueData = e.target.value;
        this.onChange(e);
      });
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      }
    },
  }
</script>

<style lang="scss">
.datetimepicker-hours, .datetimepicker-minutes {
  &>table>thead {
    display: none;
  }
  &>table>tbody>tr>td {
    width: 202px;
  }
  & .hour {
    width: 44px;
    display: inline-block;
  }
}
</style>